import initLoadIn from './utilities/load-in';
import initLazyVideo from './utilities/lazy-video';
import initScrollDirection from './utilities/scroll-direction';

import initMenu from './components/menu';
import initCookies from './components/cookies';
import initPeopleCards from './components/people-cards';
import initFetchContent from './components/fetch-content';
import initCursor from './components/cursor';
import initFeaturedAlumni from './components/featured-alumni';
import initInsights from './components/insights';
import initRelatedNews from './components/related-news';
import initVideoEmbed from './components/video-embed';
import initVideoOverlay from './components/video-overlay';
import initRelatedLinks from './components/related-links';
import initFeaturedFilm from './components/featured-film';
import initAccordions from './components/accordions';
import initContentGallery from './components/content-gallery';
import initCarousel from './components/carousel';
import initCarouselSlides from './components/carousel-slides';
import initShare from './components/share';
import initBtnHover from './components/button-hover';
import initHomeCourses from './components/home-courses';
import initAskEmbed from './components/ask-a-student';
import initFeaturedArticle from './components/featured-article';

initCookies();

initScrollDirection();

const fetchContainer = document.querySelector('.js-fetch-container');
const fetchLinks = document.querySelectorAll('.js-fetch');

if (fetchContainer && (fetchLinks && fetchLinks.length > 0)) {
    initFetchContent(fetchContainer, fetchLinks);
}

const lazyVideoEls = document.querySelectorAll('video.js-lazy');

if (lazyVideoEls) {
    initLazyVideo(lazyVideoEls);
}

const loadInEls = document.querySelectorAll('.js-load-in');

if (loadInEls && loadInEls.length > 0) {
    initLoadIn(loadInEls);
}

const menuEl = document.querySelector('.js-header');

if (menuEl) {
    initMenu(menuEl);
}

const peopleCards = document.querySelectorAll('.js-people-card');

if (peopleCards && peopleCards.length > 0) {
    initPeopleCards(peopleCards);
}

const cursorEls = document.querySelectorAll('.js-cursor');

if (cursorEls && cursorEls.length > 0) {
    initCursor(cursorEls);
}

const featuredAlumniEl = document.querySelector('.js-featured-alumni');

if (featuredAlumniEl) {
    initFeaturedAlumni(featuredAlumniEl);
}

const insightsEl = document.querySelector('.js-insights');

if (insightsEl) {
    initInsights(insightsEl);
}

const relatedNews = document.querySelectorAll('.js-related-news');

if (relatedNews && relatedNews.length > 0) {
    initRelatedNews(relatedNews);
}

const videoEmbedEls = document.querySelectorAll('.js-video-embed');

if (videoEmbedEls && videoEmbedEls.length > 0) {
    initVideoEmbed(videoEmbedEls);
}

const videoOverlays = document.querySelectorAll('.js-video-overlay');

if (videoOverlays && videoOverlays.length > 0) {
    initVideoOverlay(videoOverlays);
}

const relatedLinks = document.querySelector('.js-related-links');

if (relatedLinks) {
    initRelatedLinks(relatedLinks);
}

const featuredFilm = document.querySelector('.js-featured-film'); 

if (featuredFilm) {
    initFeaturedFilm(featuredFilm);
}

const accordionEls = document.querySelectorAll('.js-accordion');

if (accordionEls) {
    initAccordions(accordionEls);
}

const londonNavSection = document.querySelector('.js-content-gallery-section');
if (londonNavSection) {
    initContentGallery(londonNavSection);
}

const carouselSlides = document.querySelector('.js-carousel-slides');
if (carouselSlides) {
    initCarouselSlides(carouselSlides);
}

const carouselEls = document.querySelectorAll('.js-carousel');
if (carouselEls && carouselEls.length > 0) {
    initCarousel(carouselEls);
}

const shareBtns = document.querySelectorAll('.js-share-btn');
if (shareBtns && shareBtns.length > 0) {
    initShare(shareBtns);
}

const buttons = document.querySelectorAll('.js-button'); 
if (buttons && buttons.length > 0) {
    initBtnHover(buttons);
}

const homeCourses = document.querySelector('.js-home-courses');

if (homeCourses) {
    initHomeCourses(homeCourses);
}

const askBtn = document.querySelector('.js-ask-a-student');

if (askBtn) {
    initAskEmbed(askBtn);
}

const featuredArticle = document.querySelector('.js-featured-article');

if (featuredArticle) {
    initFeaturedArticle(featuredArticle);
}